import { Component } from '@angular/core';
import { WDSChanges } from '@wizeoo/akm-core-lib';
import { WizBasePopUp, WizDatasource,  WizTranslationManager} from '@wizeoo/akm-component-lib';
import { filter } from 'rxjs/operators';
import { Model } from '../../model/model';
import { LanguageVO } from '../../vo/locale/language.vo';
import { LanguageRenderer } from './renderers/language.renderer';

/**
 * renderer de la pop de séléction d'une langue de traduction
 */
@Component({
  selector: 'translation-pop',
  templateUrl: './translation.pop.html',
})
export class TranslationPop extends WizBasePopUp {
  /** Renderer de la liste des langues */
  public languageRenderer: any = LanguageRenderer;

  public data: LanguageVO;

  public get model(): Model {
    return this.datas as Model;
  }

  /** datasource de la dropdown */
  public languageListDS: WizDatasource<LanguageVO> = new WizDatasource<LanguageVO>()
    .setSortFields([{ property: 'label', way: 'asc' }])
    .build();

  /** flag d'affichage des pays associées à la langue */
  public showAssociatedCountries: boolean = true;

  /** flag indiquant si la langue sélectionnée est rattachée à au moins un pays */
  public languageHasCountries: boolean = true;

  private readonly MAX_LENGTH_LIST: number = 10;

  constructor() {
    super();
  }

  /**
   * méthode appelée après l'ouverture de la pop
   */
  public show(): void {
    super.show();
    const availableLanguage = this.model.localeEngine.getLanguageListForBU();
    const currentLanguage = availableLanguage.find((l) => l.code === this.model.currentLocaleCode);
    this.languageListDS.setSource(availableLanguage);
    this.languageListDS.setSelectedItems([currentLanguage]);

    // abonnement au changement de séléction dans la liste
    this.languageListDS.changes
      .pipe(filter((changes) => changes.type === 'selectionChanged'))
      .subscribe((changes: WDSChanges) => {
        this.onLanguageSelected(changes);
      });
  }

  /**
   * mise à jour de la langue de traduction
   * @param event, wizChange contenant la sélection de la liste
   */
  public onLanguageSelected(dsChanges: WDSChanges): void {
    if (dsChanges.value[0]) {
      WizTranslationManager.getInstance().loadTranslations(dsChanges.value[0].code);
      this.model.currentLocaleCode = dsChanges.value[0].code; // la langue en cours (celle du user))
      this.model.userContextService.saveCurrentVision({data: {language: dsChanges.value[0].code }});
    }
    // on ferme la pop
    this.hide();
  }

  /**
   * méthode appelée à la fermeture de la pop
   */
  public onHide(): void {
    super.onHide();
  }
}
